import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { LookInside } from './components/LookInside';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { askedFor, instructorReviews, tiredOf } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full bg-paper font-sans text-navy selection:bg-lav-soft selection:text-navy" data-id="element-0" data-mp="3ijfw82xf22g7">
      <MetaPixel data-id="element-1" data-mp="3mjpyb4i388ps" />
      <main data-id="element-2" data-mp="3mj6lg27aoaim">
        <Hero data-id="element-3" data-mp="3rcj6k2crlz6m" />
        <SocialProofBar data-id="element-4" data-mp="3rbzn2h7gv2qh" />
        <PainGrid data-id="element-5" data-mp="3rdkgu4lyihna" />
        <ProductReveal data-id="element-6" data-mp="3rd189ei755lx" />
        <Tomes data-id="element-7" data-mp="5yimri0b7dt" />
        <Bonuses data-id="element-8" data-mp="6hrlipoilfp" />
        <LookInside data-id="element-9" data-mp="4wv3njt0sf7" />
        <Testimonials testimonials={instructorReviews} eyebrow="From the studio floor" title="What instructors are saying" subtitle="Bollywood teachers in the US and UK on planning and running their classes with a clear structure." background="blush" data-id="element-10" data-mp="5gg5d4r3wxg" />
        <ValueStack data-id="element-11" data-mp="38kglmet3bwqk" />
        <Urgency data-id="element-12" data-mp="3dkuv81acbeqp" />
        <Pricing data-id="element-13" data-mp="3dle1ulujigpf" />
        <Testimonials testimonials={askedFor} eyebrow="We read the reviews first" title="What instructors said was missing" subtitle="Before choreographing a single class, we read what instructors say about the Bollywood videos and choreography packs they already bought. These are comments about other resources, not reviews of this pack. Every class was built to answer them." background="white" data-id="element-14" data-mp="3dlw727z6k59h" />
        <Guarantee data-id="element-15" data-mp="3uf5lnxw1mze2" />
        <Faq data-id="element-16" data-mp="d57g95652mk4" />
        <Testimonials testimonials={tiredOf} eyebrow="And what they were tired of" title="Performance videos, no breakdowns, the same five steps" subtitle="More comments on other resources. This is the gap the 4-Beat Class Arc closes." background="blush" data-id="element-17" data-mp="d4xq9hl3gfef" />
        <CostOfInaction data-id="element-18" data-mp="3bnmfxjamx78c" />
        <Close data-id="element-19" data-mp="3bk6zod585s5c" />
      </main>
      <Footer data-id="element-20" data-mp="3qaxrhl6tgr8g" />
      <PurchaseNotifications data-id="element-21" data-mp="3qbpq74vpn52y" />
    </div>;
}